class Newsletter extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('[data-form]');
    this.formMessage = this.querySelector('[data-form-message]');
    this.formButton = this.form.querySelector('button[type="submit"]');

    this.handleSubmit = this.handleSubmit.bind(this);
    this.showMessage = this.showMessage.bind(this);

    this.form.addEventListener('submit', this.handleSubmit);
  }

  async handleSubmit(e) {
    e.preventDefault();

    const formData = new FormData(this.form);
    this.formButton.setAttribute('disabled', true);

    try {
      const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        let email = formData.get('email');
        let message = window.newsletterStrings.successMessage.replace('{{ email }}', email);
        this.showMessage(message);

        this.form.reset();
      } else {
        this.showMessage(result.message || window.newsletterStrings.errorMessage);
      }
    } catch (error) {
      this.showMessage('Network error. Please try again.');
    }
  }

  showMessage(message) {
    if (!this.formMessage) return;
    this.formMessage.innerHTML = message;
    this.form.classList.toggle('hidden');
    this.formMessage.classList.toggle('hidden');
  }
}

customElements.define('newsletter-section', Newsletter);
